import { useState } from 'react';
import { FormControl, Stack, FormLabel } from '@chakra-ui/react';
import { Field } from 'formik';
import NumberField from 'components/forms/new/formikFormFields/NumberField';
import FieldToolTip from 'components/forms/new/FieldToolTip';
import { stackSpacing, formLabelStyling, stackStyling } from 'components/forms/new/formStyles';
import walkthroughIds from '../../walkthroughIds';
import NameField from 'components/forms/new/formikFormFields/NameField';

const PlanCompanySetupFeeField = ({ errors, touched, darkMode }) => {
    const [isHovered, setIsHovered] = useState(false);
    return (
        <FormControl
            sx={{ margin: '0 !important' }}
            isInvalid={!!errors.companySetupFee && touched.companySetupFee}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
        >
            
            <Stack direction="row" spacing={stackSpacing} sx={stackStyling()} >
                <FormLabel sx={formLabelStyling(darkMode)}>
                    Company Setup Fee
                </FormLabel>
                <Field
                    as={NameField}
                    id="companySetupFee"
                    name="companySetupFee"
                    data-walkthroughid={walkthroughIds.plans.ufCompanySetupFeeInput}
                    error={errors.companySetupFee}
                    type="number"
                    step="any"
                />
                {isHovered && (
                    <FieldToolTip
                        label="Company setup fee (if any)."
                        ariaLabel="plan-company-setup-fee-tip"
                        left="25px"
                        top="25px"
                    />
                )}
            </Stack>
        </FormControl>
    );
};

export default PlanCompanySetupFeeField;
